import professionalScene from '../assets/resources/scenes/tips-professional-presentation.webp'
import professionalSceneSmall from '../assets/resources/scenes/tips-professional-presentation-768.webp'
import heritageScene from '../assets/resources/scenes/tips-traditions-heritage.webp'
import heritageSceneSmall from '../assets/resources/scenes/tips-traditions-heritage-768.webp'
import travelerScene from '../assets/resources/scenes/tips-explore-city.webp'
import travelerSceneSmall from '../assets/resources/scenes/tips-explore-city-768.webp'
import dormantScene from '../assets/resources/scenes/tips-narrative-adventure.webp'
import dormantSceneSmall from '../assets/resources/scenes/tips-narrative-adventure-768.webp'
import culturalVisitScene from '../assets/resources/scenes/tips-paris-gallery.webp'
import culturalVisitSceneSmall from '../assets/resources/scenes/tips-paris-gallery-768.webp'
import dailyScene from '../assets/resources/scenes/tips-everyday-conversation.webp'
import dailySceneSmall from '../assets/resources/scenes/tips-everyday-conversation-768.webp'

const practiceScenes = [
  {
    id: 'professional',
    image: professionalScene,
    imageSmall: professionalSceneSmall,
    titleFr: 'Présentation professionnelle',
    titleEn: 'Professional presentation',
    textFr: 'Entraînez-vous à parler avec assurance devant un public.',
    textEn: 'Practice speaking confidently in front of an audience.',
    categoryFr: 'Professionnels',
    categoryEn: 'Professionals',
    moodFr: 'Assurance & expression',
    moodEn: 'Confidence & delivery',
    attributes: [
      {
        labelFr: 'Situation',
        labelEn: 'Setting',
        valueFr: 'Pitch · réunion · questions-réponses',
        valueEn: 'Pitch · meeting · Q&A',
      },
      {
        labelFr: 'Réflexes',
        labelEn: 'Skills',
        valueFr: 'Structurer · convaincre · reformuler',
        valueEn: 'Structure · persuade · rephrase',
      },
    ],
  },
  {
    id: 'heritage',
    image: heritageScene,
    imageSmall: heritageSceneSmall,
    titleFr: 'Traditions & héritage',
    titleEn: 'Traditions & heritage',
    textFr: 'Découvrez traditions, célébrations et références culturelles propres à chaque pays.',
    textEn: 'Discover the traditions, celebrations and cultural references unique to each country.',
    categoryFr: 'Héritage',
    categoryEn: 'Heritage',
    moodFr: 'Culture & transmission',
    moodEn: 'Culture & connection',
    attributes: [
      {
        labelFr: 'Situation',
        labelEn: 'Setting',
        valueFr: 'Récits · coutumes · célébrations',
        valueEn: 'Stories · customs · celebrations',
      },
      {
        labelFr: 'Réflexes',
        labelEn: 'Skills',
        valueFr: 'Décrire · comparer · transmettre',
        valueEn: 'Describe · compare · share',
      },
    ],
  },
  {
    id: 'city',
    image: travelerScene,
    imageSmall: travelerSceneSmall,
    titleFr: 'Explorer une ville',
    titleEn: 'Explore a city',
    textFr: "Apprenez le plan d’une ville, naviguez et pratiquez la langue utile en voyage.",
    textEn: 'Learn the layout, find your way and practice the language you need while traveling.',
    categoryFr: 'Voyage',
    categoryEn: 'Travel',
    moodFr: 'Orientation & découverte',
    moodEn: 'Navigation & discovery',
    attributes: [
      {
        labelFr: 'Situation',
        labelEn: 'Setting',
        valueFr: 'Plan · itinéraire · repères',
        valueEn: 'Map · route · landmarks',
      },
      {
        labelFr: 'Réflexes',
        labelEn: 'Skills',
        valueFr: 'Demander · comprendre · confirmer',
        valueEn: 'Ask · understand · confirm',
      },
    ],
  },
  {
    id: 'narrative',
    image: dormantScene,
    imageSmall: dormantSceneSmall,
    titleFr: 'Aventure narrative',
    titleEn: 'Narrative adventure',
    textFr: "Entrez dans un monde d’histoire, de secrets et de découvertes pour pratiquer en explorant.",
    textEn: 'Step into a world of stories, secrets and discovery—and practice as you explore.',
    categoryFr: 'Apprenants dormants',
    categoryEn: 'Dormant learners',
    moodFr: 'Imagination & choix',
    moodEn: 'Imagination & choices',
    attributes: [
      {
        labelFr: 'Situation',
        labelEn: 'Setting',
        valueFr: 'Indices · choix · découvertes',
        valueEn: 'Clues · choices · discoveries',
      },
      {
        labelFr: 'Réflexes',
        labelEn: 'Skills',
        valueFr: 'Interpréter · décider · raconter',
        valueEn: 'Interpret · decide · narrate',
      },
    ],
  },
  {
    id: 'cultural-visits',
    image: culturalVisitScene,
    imageSmall: culturalVisitSceneSmall,
    titleFr: 'Visites culturelles guidées',
    titleEn: 'Guided cultural visits',
    textFr: 'Avec un guide, participez à différentes expositions, visitez de véritables galeries et explorez des sites du patrimoine architectural.',
    textEn: 'With a guide, take part in different exhibitions, visit real galleries and explore architectural heritage sites.',
    categoryFr: 'Arts & patrimoine',
    categoryEn: 'Arts & heritage',
    moodFr: 'Curiosité & observation',
    moodEn: 'Curiosity & observation',
    attributes: [
      {
        labelFr: 'Situation',
        labelEn: 'Setting',
        valueFr: 'Exposition · galerie · patrimoine',
        valueEn: 'Exhibition · gallery · heritage',
      },
      {
        labelFr: 'Réflexes',
        labelEn: 'Skills',
        valueFr: 'Observer · décrire · questionner',
        valueEn: 'Observe · describe · ask',
      },
    ],
  },
  {
    id: 'everyday',
    image: dailyScene,
    imageSmall: dailySceneSmall,
    titleFr: 'Conversation du quotidien',
    titleEn: 'Everyday conversation',
    textFr: 'Café, métro, boutique, voisinage : entraînez-vous aux échanges du quotidien.',
    textEn: 'Café, metro, shop, neighborhood: practice everyday exchanges.',
    categoryFr: 'Vie quotidienne',
    categoryEn: 'Everyday life',
    moodFr: 'Pratique & spontané',
    moodEn: 'Practical & spontaneous',
    attributes: [
      {
        labelFr: 'Situation',
        labelEn: 'Setting',
        valueFr: 'Café · transport · boutique',
        valueEn: 'Café · transit · shop',
      },
      {
        labelFr: 'Réflexes',
        labelEn: 'Skills',
        valueFr: 'Saluer · demander · répondre',
        valueEn: 'Greet · ask · respond',
      },
    ],
  },
]

export default practiceScenes
